module.exports = __webpack_public_path__ + "img/it-consulting.407c4a66.png";